import { Injectable, Output, EventEmitter, Injector } from "@angular/core";
import { Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { Usuario } from "../models/usuario.model";
import { environment } from "./../../environments/environment";

export interface RecuperaPasswordMailEnviarPayload {
  email: string;
}

export interface RecuperaPasswordMailEnviarResponse {
  status: "ok";
  hash_id: number;
}

export interface RecuperaPasswordMailConfirmarPayload {
  hash_id: number;
  hash: string;
}

export interface RecuperaPasswordMailConfirmarResponse {
  status: "ok";
}

export interface RecuperaPasswordPayload {
  hash_id: number;
  hash: string;
  password: string;
}

export interface RecuperaPasswordResponse {
  status: "ok";
}

@Injectable({
  providedIn: "root",
})
export class AutentificacionService {
  url = environment.url;
  usuario: Usuario;
  mensajeOk: string;
  app_name: string;

  @Output() getLoggedInName: EventEmitter<any> = new EventEmitter();

  constructor(private http: HttpClient, private injector: Injector) { }

  //DESMOCKEAR
  login(email: string, password: string, app_name: string) {
    return this.http.post<any>(this.url + "adminapp/login", { email, password, app_name });
  }

  enviarMailRecuperacion(payload: RecuperaPasswordMailEnviarPayload) {
    return this.http.post<RecuperaPasswordMailEnviarResponse>(
      this.url + "adminapp/recupera_password/mail/enviar",
      payload
    );
  }

  confirmarMailRecuperacion(payload: RecuperaPasswordMailConfirmarPayload) {
    return this.http.post<RecuperaPasswordMailConfirmarResponse>(
      this.url + "adminapp/recupera_password/mail/confirmar",
      payload
    );
  }

  recuperarPassword(payload: RecuperaPasswordPayload) {
    return this.http.put<RecuperaPasswordResponse>(
      this.url + "adminapp/recupera_password",
      payload
    );
  }

  emitirUsuarioLogueado() {
    this.getLoggedInName.emit(this.usuario);
  }
  getUsuario() {
    return this.usuario;
  }

  getUsuarioPromise() {
    if (this.estaLogueado()) {
      const http = this.injector.get(HttpClient);
      const promise = new Promise<void>((resolve, reject) => {
        http
          .get<any>(this.url + "adminapp/me")
          .toPromise()
          .then(
            (respuesta) => {
              if (respuesta.status == "ok") {
                this.usuario = respuesta.usuario;
                this.usuario.menues = respuesta.menues;
                this.usuario.favorite_menues = respuesta.favorite_menues || [];
                this.app_name = respuesta.app_name;
                resolve();
              } else {
                this.logOut();
                resolve();
              }
            },
            (error) => {
              this.logOut();
              resolve();
            }
          );
      });
      return promise;
    }
  }

  logOut() {
    const route = this.injector.get(Router);
    this.http.post<any>(this.url + "adminapp/logout", {}).subscribe();
    this.usuario = null;
    this.app_name = null;
    localStorage.clear();
    sessionStorage.clear()
    route.navigate(["/login"]);
  }

  expulsar() {
    const route = this.injector.get(Router);
    this.usuario = null;
    this.app_name = null;
    localStorage.clear();
    sessionStorage.clear()
    route.navigate(["/login"]);
  }

  estaLogueado() {
    return localStorage.getItem("access_token") !== null;
  }

  verificaErrorAutentificacion(respuesta) {
    if (respuesta.codigo && respuesta.codigo == -1) {
      this.logOut();
    }
  }

  obtenerAppNames(email: string, source: string) {
    // return this.http.get<ApiCommonResponse & { aplicaciones: Aplicacion[] }>(this.url + "web/aplicaciones", { params: { email, cuit, source } });
    return this.http.get<any>(this.url + "adminapp/aplicaciones", { params: { email, source } });
  }

}
